import { Component, CUSTOM_ELEMENTS_SCHEMA, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { Router, RouterModule } from '@angular/router';
import { LoggingService, UserState } from '@shs-digi-care-monorepo/frontend-lib';
import { select } from '@ngxs/store';

@Component({
    selector: 'app-settings-menu',
    templateUrl: './settings-menu.component.html',
    imports: [TranslateModule, RouterModule],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SettingsMenuComponent {
    private readonly router: Router = inject(Router);
    private readonly logger = inject(LoggingService);

    protected isTaskOwner = select(UserState.isTaskOwner);

    protected openLink(link: string): void {
        switch (link) {
            case 'user-settings':
                this.router.navigate(['/settings/user']);
                break;
            case 'manage-ooo':
                this.router.navigate(['/settings/out-of-office']);
                break;
            case 'calendar-view':
                this.router.navigate(['/settings/out-of-office-calendar']);
                break;
        }
    }

    protected downloadLogs(): void {
        this.logger.downloadLogs();
    }
}
